import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";

import {
    FaEnvelope,
    FaLock,
    FaEye,
    FaEyeSlash,
    FaArrowRight,
    FaHome,
    FaGraduationCap,
    FaCheckCircle
} from "react-icons/fa";

import { userLogin } from "../config/userApi";


function Login() {

    const navigate = useNavigate();

    const [email, setEmail] = useState("");

    const [password, setPassword] = useState("");

    const [showPassword, setShowPassword] = useState(false);

    const [loading, setLoading] = useState(false);


    /*
    |--------------------------------------------------------------------------
    | Handle Login
    |--------------------------------------------------------------------------
    */

    const handleSubmit = async (e) => {

        e.preventDefault();


        /*
        |--------------------------------------------------------------------------
        | Email Validation
        |--------------------------------------------------------------------------
        */

        if (!email.trim()) {

            Swal.fire({
                icon: "warning",
                title: "Email Required",
                text: "Please enter your email address."
            });

            return;
        }


        /*
        |--------------------------------------------------------------------------
        | Password Validation
        |--------------------------------------------------------------------------
        */

        if (!password.trim()) {

            Swal.fire({
                icon: "warning",
                title: "Password Required",
                text: "Please enter your password."
            });

            return;
        }


        try {

            setLoading(true);


            console.log("================================");
            console.log("USER LOGIN REQUEST");
            console.log("Email:", email);
            console.log("================================");


            /*
            |--------------------------------------------------------------------------
            | Call User Login API
            |--------------------------------------------------------------------------
            */

            const response = await userLogin(
                email.trim(),
                password
            );


            console.log(
                "Response Status:",
                response.status
            );


            console.log(
                "Response OK:",
                response.ok
            );


            /*
            |--------------------------------------------------------------------------
            | Read Response
            |--------------------------------------------------------------------------
            */

            const responseText = await response.text();


            console.log(
                "Raw Laravel Response:",
                responseText
            );


            let data = {};


            try {

                data = JSON.parse(responseText);

            } catch (error) {

                console.error(
                    "JSON Parse Error:",
                    error
                );


                Swal.fire({
                    icon: "error",
                    title: "Invalid API Response",
                    text: "Laravel ने valid JSON response नहीं भेजा।"
                });

                return;
            }


            console.log(
                "Laravel JSON:",
                data
            );


            /*
            |--------------------------------------------------------------------------
            | Login Failed
            |--------------------------------------------------------------------------
            */

            if (!response.ok) {

                Swal.fire({
                    icon: "error",
                    title: "Login Failed",
                    text:
                        data.message ||
                        "Invalid email or password."
                });

                return;
            }


            /*
            |--------------------------------------------------------------------------
            | Login Success
            |--------------------------------------------------------------------------
            */

            console.log(
                "✅ USER LOGIN SUCCESSFUL"
            );


            /*
            |--------------------------------------------------------------------------
            | User Information
            |--------------------------------------------------------------------------
            */

            if (data.user) {

                console.log(
                    "✅ USER DATA:"
                );

                console.log(
                    data.user
                );
            }


            /*
            |--------------------------------------------------------------------------
            | Token Check
            |--------------------------------------------------------------------------
            */

            if (data.token) {

                console.log(
                    "⚠️ Token returned in JSON response:"
                );

                console.log(
                    data.token
                );

            } else {

                console.log(
                    "✅ Token is being handled through HttpOnly Cookie."
                );

            }


            /*
            |--------------------------------------------------------------------------
            | Success Message
            |--------------------------------------------------------------------------
            */

            await Swal.fire({

                icon: "success",

                title: "Login Successful",

                text:
                    "Welcome to HomeoAdda.",

                timer: 1500,

                showConfirmButton: false

            });


            /*
            |--------------------------------------------------------------------------
            | Go To Home
            |--------------------------------------------------------------------------
            */

            navigate("/");


        } catch (error) {

            console.error(
                "================================"
            );

            console.error(
                "USER LOGIN ERROR:"
            );

            console.error(
                error
            );

            console.error(
                "================================"
            );


            Swal.fire({

                icon: "error",

                title: "Connection Error",

                text:
                    error.message ||
                    "Unable to connect with server."

            });


        } finally {

            setLoading(false);

        }

    };


    return (

        <div
            className="min-vh-100 d-flex align-items-center justify-content-center position-relative overflow-hidden py-4"
            style={{
                background:
                    "linear-gradient(rgba(255,255,255,0.38), rgba(255,255,255,0.48)), url('/assets/bgimage.png')",
                backgroundSize: "cover",
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
                backgroundAttachment: "fixed"
            }}
        >


            {/* ==============================================================
                BACKGROUND DECORATION
            ============================================================== */}

            <div
                className="position-absolute rounded-circle bg-primary opacity-10"
                style={{
                    width: "320px",
                    height: "320px",
                    top: "-130px",
                    left: "-100px",
                    pointerEvents: "none"
                }}
            ></div>


            <div
                className="position-absolute rounded-circle bg-success opacity-10"
                style={{
                    width: "280px",
                    height: "280px",
                    bottom: "-120px",
                    right: "-80px",
                    pointerEvents: "none"
                }}
            ></div>


            {/* ==============================================================
                MAIN CONTAINER
            ============================================================== */}

            <div className="container position-relative">

                <div className="row justify-content-center">

                    <div className="col-12 col-sm-10 col-md-8 col-lg-5 col-xl-4">


                        {/* ==================================================
                            LOGIN CARD
                        ================================================== */}

                        <div
                            className="card border-0 shadow-lg rounded-4 overflow-hidden"
                            style={{
                                background: "rgba(255,255,255,0.97)",
                                backdropFilter: "blur(10px)",
                                WebkitBackdropFilter: "blur(10px)"
                            }}
                        >


                            {/* ==================================================
                                TOP BRAND SECTION
                            ================================================== */}

                            <div className="text-center pt-4 px-4">


                                {/* Logo */}

                                <Link
                                    to="/"
                                    className="text-decoration-none"
                                >

                                    <div
                                        className="mx-auto mb-3 d-flex align-items-center justify-content-center rounded-4 shadow-sm"
                                        style={{
                                            width: "72px",
                                            height: "72px",
                                            background:
                                                "linear-gradient(135deg, #0d6efd, #0b5ed7)"
                                        }}
                                    >

                                        <FaGraduationCap
                                            className="text-white"
                                            size={36}
                                        />

                                    </div>

                                </Link>


                                {/* Title */}

                                <h2 className="fw-bold mb-1">

                                    Welcome Back

                                </h2>


                                {/* Subtitle */}

                                <p className="text-muted mb-0">

                                    Login to continue your

                                    <span className="fw-semibold text-primary">

                                        {" "}HomeoAdda

                                    </span>

                                    {" "}journey.

                                </p>

                            </div>


                            {/* ==================================================
                                FORM
                            ================================================== */}

                            <div className="card-body p-4 p-md-4">


                                <form onSubmit={handleSubmit}>


                                    {/* ==========================================
                                        EMAIL
                                    ========================================== */}

                                    <div className="mb-3">

                                        <label
                                            className="form-label fw-semibold"
                                            htmlFor="email"
                                        >

                                            Email Address

                                        </label>


                                        <div className="input-group">

                                            <span
                                                className="input-group-text bg-light border-end-0"
                                            >

                                                <FaEnvelope
                                                    className="text-primary"
                                                    size={15}
                                                />

                                            </span>


                                            <input
                                                id="email"
                                                type="email"
                                                className="form-control bg-light border-start-0 py-2"
                                                placeholder="Enter your email"
                                                value={email}
                                                onChange={(e) =>
                                                    setEmail(
                                                        e.target.value
                                                    )
                                                }
                                                disabled={loading}
                                                autoComplete="email"
                                            />

                                        </div>

                                    </div>


                                    {/* ==========================================
                                        PASSWORD
                                    ========================================== */}

                                    <div className="mb-3">

                                        <label
                                            className="form-label fw-semibold mb-2"
                                            htmlFor="password"
                                        >

                                            Password

                                        </label>


                                        <div className="input-group">

                                            <span
                                                className="input-group-text bg-light border-end-0"
                                            >

                                                <FaLock
                                                    className="text-primary"
                                                    size={15}
                                                />

                                            </span>


                                            <input
                                                id="password"
                                                type={
                                                    showPassword
                                                        ? "text"
                                                        : "password"
                                                }
                                                className="form-control bg-light border-start-0 border-end-0 py-2"
                                                placeholder="Enter your password"
                                                value={password}
                                                onChange={(e) =>
                                                    setPassword(
                                                        e.target.value
                                                    )
                                                }
                                                disabled={loading}
                                                autoComplete="current-password"
                                            />


                                            <button
                                                type="button"
                                                className="input-group-text bg-light border-start-0"
                                                onClick={() =>
                                                    setShowPassword(
                                                        !showPassword
                                                    )
                                                }
                                                disabled={loading}
                                                aria-label={
                                                    showPassword
                                                        ? "Hide password"
                                                        : "Show password"
                                                }
                                                style={{
                                                    cursor: "pointer"
                                                }}
                                            >

                                                {showPassword ? (

                                                    <FaEyeSlash
                                                        className="text-muted"
                                                        size={15}
                                                    />

                                                ) : (

                                                    <FaEye
                                                        className="text-muted"
                                                        size={15}
                                                    />

                                                )}

                                            </button>

                                        </div>

                                    </div>


                                    {/* ==========================================
                                        REMEMBER ME
                                    ========================================== */}

                                    <div className="d-flex justify-content-between align-items-center mb-4">

                                        <div className="form-check">

                                            <input
                                                className="form-check-input"
                                                type="checkbox"
                                                id="rememberMe"
                                                disabled={loading}
                                            />


                                            <label
                                                className="form-check-label small text-muted"
                                                htmlFor="rememberMe"
                                            >

                                                Remember me

                                            </label>

                                        </div>

                                    </div>


                                    {/* ==========================================
                                        LOGIN BUTTON
                                    ========================================== */}

                                    <button
                                        type="submit"
                                        className="btn btn-primary w-100 py-2 fw-semibold rounded-3 shadow-sm"
                                        disabled={loading}
                                    >

                                        {loading ? (

                                            <>

                                                <span
                                                    className="spinner-border spinner-border-sm me-2"
                                                    role="status"
                                                    aria-hidden="true"
                                                ></span>

                                                Logging in...

                                            </>

                                        ) : (

                                            <>

                                                Login to Account

                                                <FaArrowRight
                                                    className="ms-2"
                                                    size={13}
                                                />

                                            </>

                                        )}

                                    </button>


                                </form>


                                {/* ==================================================
                                    DIVIDER
                                ================================================== */}

                                <div className="d-flex align-items-center my-4">

                                    <div className="flex-grow-1 border-top"></div>

                                    <span className="px-3 text-muted small">

                                        OR

                                    </span>

                                    <div className="flex-grow-1 border-top"></div>

                                </div>


                                {/* ==================================================
                                    SIGNUP
                                ================================================== */}

                                <p className="text-center mb-3 text-muted">

                                    Don't have an account?

                                    {" "}

                                    <Link
                                        to="/signup"
                                        className="text-primary text-decoration-none fw-bold"
                                    >

                                        Sign Up

                                    </Link>

                                </p>


                                {/* ==================================================
                                    BACK HOME
                                ================================================== */}

                                <div className="text-center">

                                    <Link
                                        to="/"
                                        className="text-decoration-none text-muted small"
                                    >

                                        <FaHome
                                            size={12}
                                            className="me-1"
                                        />

                                        Back to Home

                                    </Link>

                                </div>


                            </div>


                            {/* ==================================================
                                CARD FOOTER
                            ================================================== */}

                            <div className="bg-light border-top text-center py-3 px-3">

                                <div className="d-flex justify-content-center align-items-center gap-2">

                                    <FaCheckCircle
                                        className="text-success"
                                        size={13}
                                    />

                                    <small className="text-muted">

                                        Secure &amp; trusted learning platform

                                    </small>

                                </div>

                            </div>


                        </div>


                        {/* ==================================================
                            BOTTOM BRAND
                        ================================================== */}

                        <div className="text-center mt-3">

                            <small
                                className="text-white fw-semibold"
                                style={{
                                    textShadow:
                                        "0 1px 4px rgba(0,0,0,0.7)"
                                }}
                            >

                                © 2026 HomeoAdda. All rights reserved.

                            </small>

                        </div>


                    </div>

                </div>

            </div>

        </div>

    );

}


export default Login;